const { busApi } = require('./API');

class TimsheetService {
  // List All Timesheets
  static async listTimesheets(businessId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.get(`${businessId}/timesheets`);
    const { data } = res;
    return data;
  }

  // Delete Timesheet
  static deleteTimesheet(businessId, timesheetId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.delete(`${businessId}/timesheets/${timesheetId}`);
  }

  // Collate timesheets
  static async collateTimesheets(businessId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.post(`${businessId}/timesheets/collate`);
    const { data } = res;
    return data;
  }

  // Post timesheets to payroll
  static async postTimesheetsToPayroll(businessId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.post(`${businessId}/timesheets/postToPayroll`);
    const { data } = res;
    return data;
  }
}

export default TimsheetService;
